export const BLOCK_SCROLL = "body_scroll_blocked";